import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Benefits } from './components/Benefits';
import { ProblemSolution } from './components/ProblemSolution';
import { Services } from './components/Services';
import { About } from './components/About';
import { WhyChooseUs } from './components/WhyChooseUs';
import { HowWeHelp } from './components/HowWeHelp';
import { ContactForm } from './components/ContactForm';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-warm-white font-inter text-charcoal selection:bg-copper/20 selection:text-forest" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <Benefits data-id="element-4" />
        <ProblemSolution data-id="element-5" />
        <Services data-id="element-6" />
        <About data-id="element-7" />
        <WhyChooseUs data-id="element-8" />
        <HowWeHelp data-id="element-9" />
        <ContactForm data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}